export default class BudgetExecutionAccount {

    id?: number
    cta: number
    description: string
    group_id: number
    account_group?:AccountGroup
    created_at?: string

    constructor(values: BudgetExecutionAccountConstructorValues) {
        this.id = values.id
        this.cta = values.cta
        this.description = values.description
        this.group_id = values.group_id
        this.account_group = values.account_group
        this.created_at = values.created_at

    }
}


export interface BudgetExecutionAccountConstructorValues {
    id: number;
    cta: number;
    description: string;
    group_id: number;
    account_group:AccountGroup
    created_at?: string
}

export interface AccountGroup{
    id: number;
    name: string;
}
